import { render, staticRenderFns } from "./SimulaPropostaTabela.vue?vue&type=template&id=41274c04&"
import script from "./SimulaPropostaTabela.vue?vue&type=script&lang=js&"
export * from "./SimulaPropostaTabela.vue?vue&type=script&lang=js&"
import style0 from "./SimulaPropostaTabela.vue?vue&type=style&index=0&id=41274c04&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports